import * as React from 'react';
import {
  Row,
  Col,
  Input,
  Button,
  notify,
  RadioGroup,
  Radio,
  validate,
} from 'sha-el-design/lib';
import {
  RetailerNode,
  RetailerForApprovalMutationPayload,
  RetailerForApprovalMutationInput,
} from '../../../schema';
import { RetailerForApprovalService } from '../../service/retailerForApprovalService';
import { Inject } from '../../helpers';
import { UserService } from '../../service/userService';
import { nestedAccess } from 'sha-el-design/lib/helpers';
import { retailerValidatorObject } from './constant';

export class EditRetailer extends React.Component<Props, State> {
  static originalRetKeyObject = {
    firm: 'firm',
    proprietor: 'proprietor',
    pincode: 'pinCode',
    address: 'address',
    mobilenumber1: 'mobileNumber1',
    mobilenumber2: 'mobileNumber2',
  };
  static invertedRetKeyObject = {
    firm: 'firm',
    proprietor: 'proprietor',
    pinCode: 'pincode',
    address: 'address',
    mobileNumber1: 'mobilenumber1',
    mobileNumber2: 'mobilenumber2',
  };
  @Inject retForApprovalService: RetailerForApprovalService;
  @Inject userService: UserService;

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      retailer: { ...this.props.retailer },
      originalRetailer: { ...this.props.retailer },
      toCloseRetailer: 'No',
      isDataFromWeb: true,
      isSubmitDisabled: false,
      changedData: {},
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({ retailer: { ...nextProps.retailer }, originalRetailer: { ...nextProps.retailer } });
  }

  onChange(name: string, value: any) {
    const { retailer, changedData } = this.state;
    if (name === 'mobilenumber1' || name === 'mobilenumber2') {
      const max_chars = 10;
      if (value.length > max_chars) {
        value = value.substr(0, max_chars);
      }
    }

    retailer[name] = value;
    changedData[EditRetailer.originalRetKeyObject[name]] = value;
    this.setState({ retailer, changedData });
  }

  onCloseRetailer(e: string) {
    this.setState({ toCloseRetailer: e as any });
  }

  submit = () => {
    this.setState({ isSubmitDisabled: true });
    const newRetailerValidatorObject = { ...retailerValidatorObject };
    if (!this.state.retailer.mobilenumber2) {
      delete newRetailerValidatorObject.mobilenumber2;
    }
    const retailerSchema = validate<RetailerForApprovalMutationInput>(
      validate.Object(newRetailerValidatorObject),
    );
    const error = retailerSchema.validate(this.state.retailer);
    const isError = !Object.keys(error).every((v) => {
      return !error[v];
    });

    this.setState({ error });
    if (isError) {
      this.setState({ isSubmitDisabled: false });
      return;
    }
    const changedData = {};
    Object.keys(this.state.changedData).forEach((key) => {
      if (this.state.changedData[key] !== this.state.originalRetailer[EditRetailer.invertedRetKeyObject[key]]) {
        changedData[key] = this.state.changedData[key];
      }
    });

    const { toCloseRetailer } = this.state;
    if (!Object.keys(changedData).length && toCloseRetailer === 'No') {
      this.setState({ isSubmitDisabled: false, changedData });
      return alert('No Changed Value!');
    }

    // tslint:disable-next-line:no-string-literal
    changedData['toCloseRetailer'] = toCloseRetailer;
    this.setState({ changedData });

    const data: RetailerForApprovalMutationInput = {
      changeddata: JSON.stringify(changedData),
      retailerid: this.state.originalRetailer.id,
    };

    this.retForApprovalService.add(
      data,
      (response: {
        data: { createRetailerForApproval: RetailerForApprovalMutationPayload };
        errors: any[];
      }) => {
        if (!response.data.createRetailerForApproval && response.errors) {
          return notify({
            type: 'error',
            title: response.errors[0].message,
            duration: 3500,
            callBack: () => this.setState({ isSubmitDisabled: false }),
          });
        }
        const errors = response.data.createRetailerForApproval.errors;
        if (!errors) {
          notify({
            type: 'success',
            title: 'Retailer details sent for approval',
            callBack: () => {
              this.setState({ isSubmitDisabled: false });
              this.props.toggleModal();
              this.state.toCloseRetailer === 'Yes' && this.props.postWrongNumberOnCloseRetailer(toCloseRetailer);
            },
          });
        } else {
          notify({
            type: 'error',
            title: errors[0].field.toUpperCase(),
            message: errors[0].messages[0],
            duration: 3500,
            callBack: () => this.setState({ isSubmitDisabled: false }),
          });
        }
      },
      () =>
        notify({
          title: 'Something went wrong',
          type: 'error',
          callBack: () => this.setState({ isSubmitDisabled: false }),
        }),
    );
  }

  render() {
    const error = { ...this.state.error };
    return (
      <Row>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>Firm Name</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <Input
            value={this.state.retailer.firm}
            onChange={(e) => this.onChange('firm', e.target.value)}
            error={nestedAccess(error, 'firm')}
          />
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>Proprietor</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <Input
            value={this.state.retailer.proprietor}
            onChange={(e) => this.onChange('proprietor', e.target.value)}
            error={nestedAccess(error, 'proprietor')}
          />
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>Address</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <Input
            value={this.state.retailer.address}
            onChange={(e) => this.onChange('address', e.target.value)}
            error={nestedAccess(error, 'address')}
          />
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>Town</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <Input
            style={{
              border: 'none',
            }}
            value={
              `${this.state.retailer.townid.districtid.stateid.name}/${this.state.retailer.townid.districtid.name}/` +
              `${this.state.retailer.townid.name}`
            }
            readOnly
          />
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>Pincode</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <Input
            value={this.state.retailer.pincode}
            onChange={(e) => this.onChange('pincode', e.target.value)}
            error={nestedAccess(error, 'pincode')}
          />
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>Mobile Number</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <Input
            type='number'
            value={this.state.retailer.mobilenumber1}
            onChange={(e) => this.onChange('mobilenumber1', e.target.value)}
            error={nestedAccess(error, 'mobilenumber1')}
          />
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>Alternate Mobile Number</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <Input
            type='number'
            value={this.state.retailer.mobilenumber2}
            onChange={(e) => this.onChange('mobilenumber2', e.target.value)}
            error={nestedAccess(error, 'mobilenumber2')}
          />
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <h4 style={{ margin: 0 }}>To Close Retailer</h4>
        </Col>
        <Col style={{ margin: '10px 0' }} span={12}>
          <RadioGroup
            name='toCloseRetailer'
            value={this.state.toCloseRetailer}
            onChange={(e) => this.onCloseRetailer(e.target.value)}
          >
            <Radio value={'Yes'} label='Yes' key={'Yes'} />
            <Radio value={'No'} label='No' key={'No'} />
          </RadioGroup>
        </Col>
        <Col span={3} offset={16}>
          <Button
            style={{
              marginTop: '10px',
            }}
            onClick={this.props.toggleModal}
            type='secondary'
          >
            Cancel
          </Button>
        </Col>
        <Col span={5}>
          <Button
            style={{
              marginTop: '10px',
            }}
            type='primary'
            onClick={this.submit}
            disabled={this.state.isSubmitDisabled}
          >
            Save Changes
          </Button>
        </Col>
      </Row>
    );
  }
}

type retailerKeys = keyof RetailerNode;
interface Props {
  retailer: RetailerNode;
  toggleModal: () => void;
  postWrongNumberOnCloseRetailer: (toCloseRetailer: string) => void;
}

interface State {
  retailer: RetailerNode;
  originalRetailer: RetailerNode;
  error: Partial<{
    [key in retailerKeys]: string;
  }>;
  toCloseRetailer: string;
  isDataFromWeb: boolean;
  isSubmitDisabled: boolean;
  changedData: any;
}
